import React, { useState } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useLenis } from '@/lib/lenis';
import Nav from '@/components/site/Nav';
import Hero from '@/components/site/Hero';
import Credibility from '@/components/site/Credibility';
import WhatWeDo from '@/components/site/WhatWeDo';
import WhyNoBS from '@/components/site/WhyNoBS';
import Sectors from '@/components/site/Sectors';
import Approach from '@/components/site/Approach';
import SelectedWork from '@/components/site/SelectedWork';
import Team from '@/components/site/Team';
import Reach from '@/components/site/Reach';
import Contact from '@/components/site/Contact';
import Footer from '@/components/site/Footer';
import BookConsultation from '@/components/site/BookConsultation';

const Landing = () => {
  const [bookOpen, setBookOpen] = useState(false);
  useLenis();

  const openBook = () => setBookOpen(true);

  return (
    <div className="App relative">
      <Nav onBook={openBook} />
      <main>
        <Hero onBook={openBook} />
        <Credibility />
        <WhatWeDo />
        <WhyNoBS />
        <Sectors />
        <Approach />
        <SelectedWork />
        <Team />
        <Reach />
        <Contact onBook={openBook} />
      </main>
      <Footer />
      <BookConsultation open={bookOpen} onOpenChange={setBookOpen} />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
